import {Component} from '@angular/core';
import { StatistikService } from '../statistik.service';
import { AuthSelectors } from '../../auth/store/services';

interface NavigationTab {
    step: number;
    text: string;
    lev?: number;
}

@Component({
    selector: 'app-statistik-modal',
    templateUrl: './statistik-modal.component.html',
    standalone: false
})
export class StatistikModalComponent {
    step$ = this.statistikService.step$;
    lev$ = this.authSelector.userLev$;

    tabs: NavigationTab[] = [
        {step: 1, text: 'Produktivitet'},
        {step: 2, text: 'Tidsforbrug'},
        {step: 3, text: 'Kunder'},
        {step: 4, text: 'Igangværende'},
        {step: 5, text: 'Dækning'},
        {step: 6, text: 'Ydelse'},
        {step: 7, text: 'Norm/plan tid'},
        {step: 8, text: 'Til og afgang'},
        {step: 9, text: 'NetOms/LA', lev: 3},
    ];
    visible$ = this.statistikService.visible$;

    constructor(
        private statistikService: StatistikService,
        private authSelector: AuthSelectors,
    ) { }

    onDismiss() {
        this.statistikService.setVisible(false);
    }

    gotoTab(tab: NavigationTab) {
        this.statistikService.setStep(tab.step);
    }
}
